import {
  ControlledDateSelect,
  ControlledInput,
} from '@uikit/FormItems/ControlledItems';
import Modal from '@uikit/Modal/Modal';
import { validations } from '@utils/validations';
import React, { FC } from 'react';
import TableSection from '@uikit/Tables/TableSection/TableSection';
import { useStandingOrderSearch } from '@hooks/useStandingOrderSearch';

interface ISOSearchModal {
  closeModal: () => void;
}

const SOSearchModal: FC<ISOSearchModal> = ({ closeModal }) => {
  const { control, handleClickEdit, searchSOData, filters, isLoading } =
    useStandingOrderSearch();

  return (
    <Modal
      title="Standing Order Search"
      closeClick={closeModal}
      maxWidth="980px"
      dataTestId="ssm"
    >
      <div
        className="search-wrapper standing-order-search-wrapper"
        data-test-id="ssm"
      >
        <div
          className="modal-search-from so-search-inputs-wrapper"
          data-test-id="ssm-form"
        >
          <div className="first-row" data-test-id="ssm-row1">
            <div className="modal-search-item">
              <ControlledDateSelect
                control={control}
                name="dateFrom"
                title="Standing Order  Start"
                dataTestId="ssm-from"
              />
            </div>
            <div className="modal-search-item">
              <ControlledDateSelect
                control={control}
                name="dateTo"
                title="Standing Order  End"
                dataTestId="ssm-to"
              />
            </div>
            <div className="modal-search-item">
              <ControlledInput
                control={control}
                name="confirmationCode"
                title="Standing Order Confirmation Code"
                dataTestId="ssm-cc"
              />
            </div>

            <div className="modal-search-item">
              <ControlledInput
                name="authorizationNumber"
                title="Authorization Number"
                control={control}
                type="alphanumeric"
                dataTestId="ssm-auth"
              />
            </div>
          </div>

          <div className="second-row" data-test-id="ssm-row2">
            <div className="modal-search-item">
              <ControlledInput
                control={control}
                name="memberId"
                title="Member ID"
                dataTestId="ssm-mid"
              />
            </div>

            <div className="modal-search-item">
              <ControlledInput
                name="primaryContactNumber"
                mask="(999) 999-9999"
                title="Contact Number"
                control={control}
                rules={{
                  validate: {
                    exactLength: (value) =>
                      validations.length('Primary Contact Number', value, 10),
                  },
                }}
                dataTestId="ssm-phone"
              />
            </div>
            <div className="modal-search-item">
              <ControlledInput
                name="memberFirstName"
                title="Member First Name"
                control={control}
                dataTestId="ssm-fn"
              />
            </div>

            <div className="modal-search-item">
              <ControlledInput
                name="memberLastName"
                title="Member Last Name"
                control={control}
                dataTestId="ssm-ln"
              />
            </div>
          </div>
        </div>

        {[
          {
            ...searchSOData,
            title: 'Search Result',
            isLoading: isLoading,
            argument: { body: filters },
          },
        ].map((config) => (
          <TableSection
            key={config.title}
            dataTestId={`ssm-res-${config.title}`}
            title={config.title}
            isLoading={config.isLoading}
            openModal={config.openModal}
            permissions={config.permissions}
            requestTablePageChange={config.requestTablePageChange}
            tableCustomClassName={[
              'standing-order-search-results-table',
              config.tableCustomClassName,
            ]
              .filter(Boolean)
              .join(' ')}
            hasCreatePermission={false}
            showTable={true}
            tableName={config.table}
            sortBy={config.sortBy}
            sortDir={config.sortDir}
            onEditClick={config.handleEditClick}
            rows={config.rows}
            page={config.page}
            columns={config.columns}
            totalElements={config.totalElements}
            size={config.size}
            totalPages={config.totalPages}
            modalName={config.modalName}
            addBtnTitle={config.addBtnTitle}
            argument={config.argument}
            isFilterable={false}
            arrowIconMember={true}
            handleSelectedRow={handleClickEdit}
            infiniteScroll={true}
          />
        ))}
      </div>
    </Modal>
  );
};

export default SOSearchModal;
